<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">课程管理</Breadcrumb-item>
        <Breadcrumb-item>课程音频</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 20px" @keyup.enter="search">
    <Form ref="previewForm" class="form"
          :model="queryParam" :label-width="80" label-position="left">
    <Row :gutter="32">
        <Col :span="5">
        <Form-item label="教材版本">
          <Select v-model.number="queryParam.materialVersion" clearable @on-change="onVersionChange">
            <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="5">
        <Form-item label="课程等级">
          <Select v-model.number="queryParam.levelId" clearable filterable @on-change="onLevelChange">
            <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="5">
        <Form-item label="课程标题">
          <Select v-model.number="queryParam.lessonId" clearable filterable @on-change="onLessonChange">
            <Option v-for="item in lessons" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
      <Col :span="5">
        <Form-item label="音乐标题">
          <Input v-model="queryParam.title" type="text" placeholder="支持模糊搜索"></Input>
        </Form-item>
      </Col>
      <Col>
        <Button style="margin-left: 10px" type="primary" @click="search">搜索</Button>
      </Col>
    </Row>
    </Form>
<!--      <Button type="primary" @click="addLessonVideo">添加</Button>-->
    </div>
    <List style="margin-top: 10px" ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLessonAudio/listByPage"
          :params="queryParam"></List>
    <LessonAudioInsertModal :value="showInsertModal" :successCallback="search" @on-close="closeModal"></LessonAudioInsertModal>
    <LessonAudioUpdateModal :value="showUpdateModal" :successCallback="search" :id="id" @on-close="closeModal"></LessonAudioUpdateModal>
  </div>
</template>
<script>
  import LessonAudioInsertModal from './LessonAudioInsertModal'
  import LessonAudioUpdateModal from './LessonAudioUpdateModal'
  export default {
    components: {
      LessonAudioUpdateModal,
      LessonAudioInsertModal
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        onLoading: false,
        queryParam: {
          materialVersion: '',
          levelId: '',
          lessonId: '',
          title: ''
        },
        levels: [],
        lessons: [],
        showInsertModal: false,
        showUpdateModal: false,
        title: [
          {
            title: 'ID',
            key: 'lessonId',
            // width: 80
            align: 'center',
          },
          {
            title: '教材版本',
            key: 'materialVersion',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let version = params.row.materialVersion
              let materialVersion = $constant.getEnum($constant.materialVersions, version)
              return h('span', materialVersion && materialVersion.text)
            }
          },
          {
            title: '课程等级',
            key: 'levelTitle',
            // width: 150,
            align: 'center',
          },
          {
            title: '课程标题',
            key: 'lessonTitle',
            // width: 170,
            align: 'center',
          },
          {
            title: '音频标题',
            key: 'title',
            // width: 100
            align: 'center',
          },
          {
            title: '音频地址',
            // key: 'audioUrl',
            // width: 200,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              if (row.audioUrl) {
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showIndex(row.audioUrl)}}, row.audioUrl)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '创建时间',
            key: 'gmtCreate',
            width: 170,
            align: 'center',
          },
          {
            title: '创建人',
            key: 'creatorName',
            // width: 150
            align: 'center',
          },
          {
            title: '更新时间',
            key: 'gmtModified',
            align: 'center',
            width: 170
          },
          {
            title: '最新操作人',
            key: 'modifierName',
            // width: 150
            align: 'center',
          },
          {
            title: '操作',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let spans = [h('a', {on: {click: () => this.editLesson(row.lessonId)}}, '编辑')]
              if (row.id) {
                spans.push(h('span', ' | '))
                spans.push(h('a', {on: {click: () => this.delete(row.id)}}, '删除'))
              }
              return h('span', spans)
            }
          },
        ],
        id: null
      }
    },
    mounted: function () {
      let self = this
      let query = self.$route.query
      if (query) {
        if (query.materialVersion) {
          self.queryParam.materialVersion = query.materialVersion
        }
        if (query.levelId) {
          self.queryParam.levelId = parseInt(query.levelId)
        }
        if (query.lessonId) {
          self.queryParam.lessonId = parseInt(query.lessonId)
        }
        if (query.title) {
          self.queryParam.title = query.title
        }
      }
    },
    created: function () {
    },
    methods: {
      delete (id) {
        let self = this
        if (id) {
          self.$Modal.confirm({
            title: '提示',
            content: '确认删除该音频？',
            width: 300,
            okText: '确定',
            onOk: () => {
              self.$http.post('/bookLessonAudio/delById', {id: id}).then(function (res) {
                if (res.data > 0) {
                  self.$Message.success('删除成功!')
                  self.search()
                }
              }).catch(function (e) {
                self.$Message.error(e.msg)
              })
            }
          })
        }
      },
      showIndex (audioUrl) {
        if (audioUrl) {
          window.open('http://medias.kouyujie.cn/' + audioUrl + '?' + Date.parse(new Date()))
        }
      },
      addLessonVideo () {
        this.showInsertModal = true
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
        this.search()
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLessonChange (val) {
        this.queryParam.lessonId = val
        this.search()
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
        this.search()
      },
      editLesson (id) {
        this.showUpdateModal = true
        this.id = id
      },
      closeModal () {
        this.showUpdateModal = false
        this.showInsertModal = false
        this.id = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonAudioList.vue?117a7ed2